export default __webpack_public_path__ + "static/media/icon-delete.36c59779.svg";